import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-alarms-status-major",
  "use": "app-icon-alarms-status-major-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-alarms-status-major\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FAFBFF\" cx=\"8\" cy=\"8\" r=\"8\" /><path fill=\"#FA8E5A\" d=\"M8 7l1.5-5L4 8.5 7 9l-1.5 5L11 7.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol